import { useMemo } from 'react'
import { resolveEntityIdentity } from '@solum/experience'
import { useEntityIdentities, useSchema } from './queries'

/**
 * ONE entity's nouns — the governed identity's singular and plural (#3027).
 *
 * The rail names a generic list by `plural_label` (`buildNav`), so the list's
 * title, search placeholder, count noun and the crumb back to it must read the
 * SAME field. They read `core.entity_type.label` instead — the singular table
 * name — and the owner's walkthrough found every generic list titled "KB
 * Article" / "Health Snapshot" / "Person" under a rail that said otherwise,
 * with a footer of "11 persons" from a client-side `pluralize` of "Person".
 * An irregular plural is the registry's to state (`People`), never this host's.
 *
 * Its own module, and that is deliberate: it composes two `queries.ts` hooks
 * through an import, so a test that mocks `./queries` gets this hook over its
 * OWN schema and identities instead of needing a third stand-in that could
 * disagree with them.
 */
export function useEntityNoun(entity: string): { singular: string; plural: string } {
  const schema = useSchema()
  const identities = useEntityIdentities()
  return useMemo(() => {
    const identity = resolveEntityIdentity(
      { entities: schema.data?.entities ?? [], relationships: [] }, identities.data, entity)
    return { singular: identity.singularLabel, plural: identity.pluralLabel }
  }, [schema.data, identities.data, entity])
}
